export default "__VITE_ASSET__DQl0CBDG__"